import { useEffect } from "react";

const WindowHeightChecker = () => {
  function CalculateHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }

  useEffect(() => {
    CalculateHeight();
    window.addEventListener("resize", () => CalculateHeight());
    return () => {
      window.removeEventListener("resize", () => CalculateHeight());
    };
  }, []);
  return null;
};
export default WindowHeightChecker;
